var logger = require('./logger');

function NetworkHandler() {
    this.uploadQueue = [];
    this.isProcessing = false;
    // 绑定this
    this.handleNetworkChange = this.handleNetworkChange.bind(this);
    this.handleOnline = this.handleOnline.bind(this);
    this.handleOffline = this.handleOffline.bind(this);
}

NetworkHandler.prototype.init = function() {
    window.addEventListener('networkStatusChange', this.handleNetworkChange);
    window.addEventListener('online', this.handleOnline);
    window.addEventListener('offline', this.handleOffline);
};

NetworkHandler.prototype.handleNetworkChange = function(event) {
    // event 可能是 CustomEvent 或直接 metrics
    var metrics = event && event.detail ? event.detail : event;
    logger.log('[umu-upload] Network status changed', metrics);
};

NetworkHandler.prototype.handleOnline = function() {
    logger.log('[umu-upload] Network is online');
};

NetworkHandler.prototype.handleOffline = function() {
    logger.log('[umu-upload] Network is offline');
};

NetworkHandler.prototype.destroy = function() {
    window.removeEventListener('networkStatusChange', this.handleNetworkChange);
    window.removeEventListener('online', this.handleOnline);
    window.removeEventListener('offline', this.handleOffline);
};

var networkHandler = new NetworkHandler();

module.exports = networkHandler;
